module.exports = __webpack_public_path__ + "static/media/HRECOS_PANEL_PH.d3baa8cb.png";